import React, { useState,useEffect } from 'react';
import { Button, message,AutoComplete, Steps, Form, Input, Select,Radio,DatePicker } from 'antd/lib';
import { NavbarJourney } from "../Navbar/NavbarJourney";
import { useDispatch, useSelector } from "react-redux";
import { addtraveldetails, addtravelnum } from "../../Redux/actions/NumTravel";
import { LeftOutlined} from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import countries from "./Country";
import moment from 'moment';

const { Step } = Steps;
const { RangePicker } = DatePicker;

const StepForm = () => {
  const { Option } = Select;
    const dispatch = useDispatch();
    const history = useHistory();
    const travelnum = useSelector((state) => state.traveldetail.travelnum);
    const travelDetail = useSelector((state) => state.traveldetail)
    const [current, setCurrent] = useState(0);
    const [form] = Form.useForm();
    const [options, setOptions] = useState([]);
    const [DateRange, setDateRange] = useState('')
    const [DayDiff, setDaydiff] = useState('');

    useEffect(() => {
      if (travelDetail?.travelDate) {
        const [startDateStr, endDateStr] = travelDetail?.travelDate.split(' to ');
        const startDate = moment(startDateStr, 'YYYY-MM-DD');
        const endDate = moment(endDateStr, 'YYYY-MM-DD');
        const formattedDates = `${startDate.format('YYYY-MM-DD')} to ${endDate.format('YYYY-MM-DD')}`;
        setDateRange(formattedDates)
        form.setFieldsValue({ StartAndEndDate: [startDate, endDate] });
        const duration = moment.duration(endDate.diff(startDate));
        const daysDifference = duration.asDays();
        setDaydiff(daysDifference)
      }
    }, [DateRange]);
  
    const handleSearch = (value) => {
      const filteredOptions = countries.filter((option) =>
      option.toLowerCase().includes(value.toLowerCase())
    );
    console.log(filteredOptions)
      setOptions(filteredOptions);
    };
    const onSelectMake = (data) => {
      console.log("onSelect", data);
      data = data.toUpperCase();
      form.setFieldsValue({ Destination: data });
      // setCountry(data);
    };
    const disabledDate = (current) => {
      const today = moment().startOf('day');
      return current && current < today;
    };
    const onDateChange = (dates) => {
      console.log(dates)
      // const combinedDateRange = `${dateString[0]} to ${dateString[1]}`;
      // setDateRange(combinedDateRange);
      // setStartDate(dateString[0])
      // setEndDate(dateString[1])
      if (dates && dates.length === 2) {
        const formattedDates = `${dates[0].format('YYYY-MM-DD')} to ${dates[1].format('YYYY-MM-DD')}`;
        console.log(formattedDates)
      }
      const startDate = dates[0];
      const endDate = dates[1];
      // Calculate difference in days
      const duration = moment.duration(endDate.diff(startDate));
      const daysDifference = duration.asDays();
      console.log(daysDifference)
      setDaydiff(daysDifference)
    }
   const next = (value) => {
      console.log('next value',value)
      console.log(value)
      let formattedDates;
      if (value.StartAndEndDate) {
        formattedDates = `${value.StartAndEndDate[0].format('YYYY-MM-DD')} to ${value.StartAndEndDate[1].format('YYYY-MM-DD')}`;
        console.log(formattedDates)
        //setDateRange(formattedDates)
      }
      console.log(formattedDates)
      dispatch(
        addtraveldetails({
          Destination: value.Destination ? value.Destination : travelDetail?.travelDestination,
          startAndEndDate: value.StartAndEndDate ? formattedDates : travelDetail?.travelDate,
          noOfTravellers : value.noOfPeoples ? value.noOfPeoples : travelDetail?.noOfpeoples,
          MedicalCondition: value.MedicalCondition ? value.MedicalCondition : travelDetail?.medical,
          phonenumber: travelDetail?.contact,
        })
      );
      setCurrent(current + 1);
    };
  const onFinish = (values) => {
    console.log(travelnum)
    console.log(values)
    message.success('Processing complete!');
    dispatch(
        addtraveldetails({
          Destination:  travelDetail?.travelDestination,
          startAndEndDate: travelDetail?.travelDate,
          noOfTravellers : travelDetail?.noOfpeoples,
          MedicalCondition: travelDetail?.medical,
          phonenumber: values.phonenumber ? values.phonenumber : travelDetail?.contact,
        })
      );
    history.push("/planlayout5");
  };
  const prefixSelector = (
    <Select
      style={{
        width: 70,
      }}
      defaultValue='+91'
    >
      <Option value="+91">+91</Option>
    </Select>
  );
  const steps = [
    {
      title: 'Destinations',
      content: (
        <div className='step-container'>
        <h3>Let's secure your travel</h3>
        <p>Which country are you travelling to?</p>
        <Form
          form={form}
          layout="vertical"
          className='mx-auto'
          requiredMark={false}
          initialValues={{ field2: '' }}
          onFinish={next}
        >
          <Form.Item 
          initialValue={travelDetail?.travelDestination}
            name='Destination'
            rules={[
              { required: true,
                message: 'Select Country' },
            ]}>
            <AutoComplete
              style={{width: '75%'}}
              onSearch={handleSearch}
              placeholder="Search countries"
              options={options?.map((option, index) => ({
                key: index,
                value: option,
              }))}
              onSelect={onSelectMake}
            >
            </AutoComplete>
          </Form.Item>
          <Form.Item className='step-btn-nxt'>
            <Button type="primary" htmlType="submit">
              Next
            </Button>
          </Form.Item>
        </Form>
        </div>
      ),
    },
    {
      title: 'Trip date',
      content: (
        <div className='step-container'>
        <h3>When are you travelling to {travelDetail?.travelDestination}?</h3>
        <p>Don't worry you can change your trip dates at a later stage</p>
        <Form
          form={form}
          layout="vertical"
          className='mx-auto'
          requiredMark={false}
          initialValues={{ field3: '' }}
          onFinish={next}
            >
            <Form.Item 
                name='StartAndEndDate'
                rules={[
                {
                required: true, 
                message: 'please Select Start & EndDate of Your Trip'
                }]}
                //initialValue={moment(travelDetail?.travelDate)}
                >
                <RangePicker
                disabledDate={disabledDate}
                style={{width: '75%'}}
                onChange={onDateChange}
                />
            </Form.Item>
            <p>Trip Duration: {DayDiff} Days</p>
            <Form.Item className='step-btn-nxt'>
            <Button type="primary" htmlType="submit">
              Next
            </Button>
          </Form.Item>
        </Form>
        </div>
      ),
    },
    {
        title: 'Travellers',
        content: (
          <div className='step-container'>
          <h3>How many people are travelling?</h3>
          <Form
            form={form}
            layout="vertical"
            className='mx-auto'
            requiredMark={false}
            initialValues={{ field5: '' }}
            onFinish={next}
              >
              <Form.Item
                  name='noOfPeoples'
                  rules={[
                  {
                  required: true, 
                  message: 'please Select Number of Peoples'
                  }]}
                  initialValue={travelDetail?.noOfpeoples}
                  >
                  <Radio.Group className='Radio-group'>
                    <Radio.Button className='Radio-inner' value='1'>1</Radio.Button>
                    <Radio.Button className='Radio-inner' value='2'>2</Radio.Button>
                    <Radio.Button className='Radio-inner' value='3'>3</Radio.Button>
                    <Radio.Button className='Radio-inner' value='4+'>4+</Radio.Button>
                  </Radio.Group>
              </Form.Item>
              <Form.Item className='step-btn-nxt'>
                <Button type="primary" htmlType="submit">
                  Next
                </Button>
              </Form.Item>
          </Form>
          </div>
        ),
      },
      {
        title: 'Medical history',
        content: (
          <div className='step-container'>
          <h3>Does the traveller have any pre-existing medical condition?</h3>
          <p>If the traveller have a known illness, injury or health condition like heart disease, diabetes, cancer etc which will help us cover you</p>
          <Form
            form={form}
            layout="vertical"
            className='mx-auto'
            requiredMark={false}
            initialValues={{ field4: '' }}
            onFinish={next}
              >
              <Form.Item 
                  name='MedicalCondition'
                  rules={[
                  {
                  required: true, 
                  message: 'please Select Your Medical Condition'
                  }]}
                  initialValue={travelDetail?.medical}
                  >
                    <Radio.Group className='Radio-group'>
                    <Radio.Button className='Radio-inner' value='Yes'>Yes</Radio.Button>
                    <Radio.Button className='Radio-inner' value='No'>No</Radio.Button>
                    </Radio.Group>
              </Form.Item>
              <Form.Item className='step-btn-nxt'>
                <Button type="primary" htmlType="submit">
                  Next
                </Button>
            </Form.Item>
          </Form>
          </div>
        ),
      },
      {
        title: 'Contact details',
        content: (
          <div className='step-container'>
          <h3>Great! One last step to get your travel insurance plans</h3>
          <p>We will send you the policy document on this number</p>
          <Form
            form={form}
            layout="vertical"
            className='mx-auto'
            requiredMark={false}
            initialValues={{ field4: '' }}
            onFinish={onFinish}
              >
                <Form.Item
                initialValue={travelDetail?.contact}
                  name='phonenumber'
                  //label=""
                  rules={[
                    {
                      pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                      message: 'Invalid Mobile No',
                    },
                    { required: true, message: 'Enter Mobile No' },
                  ]}
                >
                <Input
                  style={{width: '75%'}}
                  maxLength={10}
                  addonBefore={prefixSelector}
                  placeholder="Enter Mobile Number (eg. 9876543210)"
                  >
                </Input>
            </Form.Item>
            <Form.Item className='step-btn-nxt'>
            <Button type="primary" htmlType="submit">
              Get Quotes
            </Button>
          </Form.Item>
          </Form>
          </div>
        ),
      },          
  ];

  return (
    <>
    <NavbarJourney />
    <section className="bg-light py-5" style={{ minHeight: 'calc(100vh - 50px)' }}>
        <div className='container'>
          <div className='stp-bckwrd'>
            {current > 0 && (
              <LeftOutlined onClick={() => setCurrent(current - 1)}/>
            )}
          </div>
          <div className="row justify-content-center">
              <Steps
                style={{width: "70%"}}
                current={current} 
                progressDot
                >
                  {steps.map((item) => (
                    <Step
                    key={item.title} 
                    title={item.title} 
                    />
                  ))}
              </Steps>
              <div 
                className='text-center'
                style={{ marginTop: '24px' }}>
                {steps[current].content}
              </div>
            </div>
        </div>
    </section>
    </>
  );
};

export default StepForm;
